import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-brand-blue mx-auto mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10a.5.5 0 01-.5.5h-5a.5.5 0 010-1h5a.5.5 0 01.5.5z" transform="rotate(15 12 12)" />
    </svg>
);

export default function NotFoundPage() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background text-center px-4">
            <div className="max-w-md">
                <NotFoundIcon />
                <h1 className="text-5xl font-extrabold text-text-primary">404</h1>
                <h2 className="text-2xl font-bold text-text-secondary mt-2 mb-6">Página Não Encontrada</h2>
                <p className="text-text-secondary mb-8">
                    Oops! A página que você está procurando não existe. Ela pode ter sido movida ou removida.
                </p>
                <Link 
                    to="/"
                    className="px-8 py-3 bg-brand-blue text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-300"
                >
                    Voltar para a Página Inicial
                </Link>
            </div>
        </div>
    );
}
